import React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLanguage } from "@fortawesome/free-solid-svg-icons";
import { fallbackLanguage, savedLanguageKey } from "../i18n";

const languageOptions = [
  { value: "pt", label: "PT" },
  { value: "en", label: "EN" },
  { value: "es", label: "ES" },
];

const SelectorWrap = styled.label`
  position: relative;
  display: inline-flex;
  align-items: center;
  width: fit-content;
  margin: 0;
`;

const LanguageIcon = styled(FontAwesomeIcon)`
  position: absolute;
  left: 10px;
  color: #ee754c;
  font-size: 16px;
  pointer-events: none;
  z-index: 1;
`;

const Select = styled.select`
  height: 36px;
  min-width: 78px;
  border: 1px solid #ee754c;
  border-radius: 8px;
  background: #fffaf0;
  color: #4b3335;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  padding: 0 28px 0 34px;
  outline: none;
  transition:
    border-color 0.2s ease,
    box-shadow 0.2s ease;

  &:hover,
  &:focus {
    border-color: #d65f34;
    box-shadow: 0 0 0 2px rgba(238, 117, 76, 0.16);
  }
`;

const LanguageSelector = ({ className }) => {
  const { i18n, t } = useTranslation();
  const currentLanguage = (
    i18n.resolvedLanguage ||
    i18n.language ||
    fallbackLanguage
  ).split("-")[0];

  const handleChange = (event) => {
    const selectedLanguage = event.target.value;
    window.localStorage.setItem(savedLanguageKey, selectedLanguage);
    i18n.changeLanguage(selectedLanguage);
  };

  return (
    <SelectorWrap className={className}>
      <LanguageIcon icon={faLanguage} />
      <Select
        value={currentLanguage}
        onChange={handleChange}
        aria-label={t("common.language")}
      >
        {languageOptions.map((language) => (
          <option key={language.value} value={language.value}>
            {language.label}
          </option>
        ))}
      </Select>
    </SelectorWrap>
  );
};

export default LanguageSelector;
